import { css } from "styled-components"

export const sansSerifStyles = ({ size = 18 } = {}) => `
  font-family: proximanova, helvetica neue, sans-serif !important;
  font-size: ${size}px;
`

export const serifStyles = ({ size = 20 } = {}) => `
  font-family: FreightText,Georgia,serif;
  font-size: ${size}px;
`

export const blocksFontCSS = ({ size = 18, type = "sans" } = {}) => css`
  .BlockText,
  .BlockText p,
  .ContentText,
  .ql-editor,
  .ql-editor p,
  .ql-editor.ql-blank:before {
    ${type === "sans" ? sansSerifStyles({ size }) : serifStyles({ size })}
  }
`
